module.exports = __webpack_public_path__ + "static/img/benefits_7.dc955e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/benefits/benefits_7.png
// module id = cu/4
// module chunks = 1